import { UploadFlow } from '@cibo/landmanager'
import { useParamAsInteger } from '@cibo/ui'
import { LayoutSection } from 'components/ImpactLayout'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'

export const UserUploadFlow = ({ navSuccessRoute }: { navSuccessRoute: string }) => {
  const { t } = useTranslation('impact/pages/UploadFlow')
  const navigate = useNavigate()
  const userId = useParamAsInteger('userId')

  const { enqueueSnackbar } = useSnackbar()

  return (
    <LayoutSection container>
      <UploadFlow
        onComplete={(importedFieldIds: string[]) => {
          enqueueSnackbar(t('uploadingField', { count: importedFieldIds.length }), {
            variant: 'success',
          })
          navigate(generatePath(navSuccessRoute, { userId: userId?.toString() }))
        }}
        userId={userId}
      />
    </LayoutSection>
  )
}
